import { Link } from 'react-router-dom'
import redesignImg from '../images/redesign.webp'

function Footer() {
  return (
    <footer className="footer-area">
    <div className="container">
      <div className="f-inner">
        <div className="f-left">
          <Link to="/">
            <img src={redesignImg} alt="redesign" />
          </Link>
          <p>
            Get ready to dive into the world of exciting games designed
            purely for your entertainment. IlmaKierroksetFinoffers a free online
            social casino platform, where all game functions and rewards are
            virtual and have no real monetary value. This means you can
            enjoy the thrill of casino games without the risk of losing real
            money. Please note that IlmaKierroksetFin intended for persons
            over the age of 19. By using our platform, you confirm that you
            meet this age requirement.
          </p>
        </div>
        <div className="f-r">
          <div className="f-r-title">
            <h3>Contact Info</h3>
          </div>
          <div className="f-r-btm">
            <p>
              <span>Location:</span>
            </p>
            <p>
              Matti Meikäläinen Esimerkkikatu 12 A 5 00100 Helsinki Finland
            </p>
          </div>
          <div className="f-r-btm">
            <p>
              <span>Phone:</span>
            </p>
            <Link to="/">+358 40 256 1121</Link>
          </div>
          <ul>
            <li>
              <Link to="/">Terms of Service</Link>
            </li>
            <li>
              <Link to="/">Privacy Policy</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="copy">
        <span>
          © 2021 IlmaKierroksetFin.com Made by{" "}
          <Link to="/">IlmaKierroksetFin.com</Link>
        </span>
      </div>
    </div>
  </footer>
  )
}

export default Footer
